import accordion from '@primeuix/themes/aura/accordion';
import autocomplete from '@primeuix/themes/aura/autocomplete';
import avatar from '@primeuix/themes/aura/avatar';
import badge from '@primeuix/themes/aura/badge';
import blockui from '@primeuix/themes/aura/blockui';
import breadcrumb from '@primeuix/themes/aura/breadcrumb';
import card from '@primeuix/themes/aura/card';
import carousel from '@primeuix/themes/aura/carousel';
import cascadeselect from '@primeuix/themes/aura/cascadeselect';
import chip from '@primeuix/themes/aura/chip';
import colorpicker from '@primeuix/themes/aura/colorpicker';
import confirmdialog from '@primeuix/themes/aura/confirmdialog';
import confirmpopup from '@primeuix/themes/aura/confirmpopup';
import contextmenu from '@primeuix/themes/aura/contextmenu';
import dataview from '@primeuix/themes/aura/dataview';
import datepicker from '@primeuix/themes/aura/datepicker';
import dialog from '@primeuix/themes/aura/dialog';
import divider from '@primeuix/themes/aura/divider';
import dock from '@primeuix/themes/aura/dock';
import drawer from '@primeuix/themes/aura/drawer';
import editor from '@primeuix/themes/aura/editor';
import fieldset from '@primeuix/themes/aura/fieldset';
import fileupload from '@primeuix/themes/aura/fileupload';
import floatlabel from '@primeuix/themes/aura/floatlabel';
import galleria from '@primeuix/themes/aura/galleria';
import iconfield from '@primeuix/themes/aura/iconfield';
import image from '@primeuix/themes/aura/image';
import inlinemessage from '@primeuix/themes/aura/inlinemessage';
import inplace from '@primeuix/themes/aura/inplace';
import inputchips from '@primeuix/themes/aura/inputchips';
import inputgroup from '@primeuix/themes/aura/inputgroup';
import inputnumber from '@primeuix/themes/aura/inputnumber';
import knob from '@primeuix/themes/aura/knob';
import listbox from '@primeuix/themes/aura/listbox';
import megamenu from '@primeuix/themes/aura/megamenu';
import menu from '@primeuix/themes/aura/menu';
import menubar from '@primeuix/themes/aura/menubar';
import message from '@primeuix/themes/aura/message';
import metergroup from '@primeuix/themes/aura/metergroup';
import multiselect from '@primeuix/themes/aura/multiselect';
import orderlist from '@primeuix/themes/aura/orderlist';
import overlaybadge from '@primeuix/themes/aura/overlaybadge';
import paginator from '@primeuix/themes/aura/paginator';
import panelmenu from '@primeuix/themes/aura/panelmenu';
import password from '@primeuix/themes/aura/password';
import picklist from '@primeuix/themes/aura/picklist';
import popover from '@primeuix/themes/aura/popover';
import progressbar from '@primeuix/themes/aura/progressbar';
import progressspinner from '@primeuix/themes/aura/progressspinner';
import radiobutton from '@primeuix/themes/aura/radiobutton';
import rating from '@primeuix/themes/aura/rating';
import ripple from '@primeuix/themes/aura/ripple';
import scrollpanel from '@primeuix/themes/aura/scrollpanel';
import selectbutton from '@primeuix/themes/aura/selectbutton';
import skeleton from '@primeuix/themes/aura/skeleton';
import slider from '@primeuix/themes/aura/slider';
import speeddial from '@primeuix/themes/aura/speeddial';
import splitbutton from '@primeuix/themes/aura/splitbutton';
import splitter from '@primeuix/themes/aura/splitter';
import stepper from '@primeuix/themes/aura/stepper';
import steps from '@primeuix/themes/aura/steps';
import tabmenu from '@primeuix/themes/aura/tabmenu';
import tabview from '@primeuix/themes/aura/tabview';
import terminal from '@primeuix/themes/aura/terminal';
import tieredmenu from '@primeuix/themes/aura/tieredmenu';
import timeline from '@primeuix/themes/aura/timeline';
import toast from '@primeuix/themes/aura/toast';
import togglebutton from '@primeuix/themes/aura/togglebutton';
import toggleswitch from '@primeuix/themes/aura/toggleswitch';
import tooltip from '@primeuix/themes/aura/tooltip';
import tree from '@primeuix/themes/aura/tree';
import treeselect from '@primeuix/themes/aura/treeselect';
import treetable from '@primeuix/themes/aura/treetable';
import virtualscroller from '@primeuix/themes/aura/virtualscroller';

import base from './base';
import button from './button';
import checkbox from './checkbox';
import datatable from './datatable';
import inputtext from './inputtext';
import organizationchart from './organizationchart';
import panel from './panel';
import select from './select';
import tabs from './tabs';
import tag from './tag';
import textarea from './textarea';
import toolbar from './toolbar';

const index = {
  ...base,
  components: {
    accordion,
    autocomplete,
    avatar,
    badge,
    blockui,
    breadcrumb,
    button,
    datepicker,
    card,
    carousel,
    cascadeselect,
    checkbox,
    chip,
    colorpicker,
    confirmdialog,
    confirmpopup,
    contextmenu,
    dataview,
    datatable,
    dialog,
    divider,
    dock,
    drawer,
    editor,
    fieldset,
    fileupload,
    floatlabel,
    galleria,
    iconfield,
    image,
    inlinemessage,
    inplace,
    inputchips,
    inputgroup,
    inputnumber,
    inputtext,
    knob,
    listbox,
    megamenu,
    menu,
    menubar,
    message,
    metergroup,
    multiselect,
    orderlist,
    organizationchart,
    overlaybadge,
    popover,
    paginator,
    password,
    panel,
    panelmenu,
    picklist,
    progressbar,
    progressspinner,
    radiobutton,
    rating,
    scrollpanel,
    select,
    selectbutton,
    skeleton,
    slider,
    speeddial,
    splitter,
    splitbutton,
    stepper,
    steps,
    tabmenu,
    tabs,
    tabview,
    textarea,
    tieredmenu,
    tag,
    terminal,
    timeline,
    togglebutton,
    toggleswitch,
    tree,
    treeselect,
    treetable,
    toast,
    toolbar,
    virtualscroller,
  },
  directives: { tooltip, ripple },
};

export default index;
//# sourceMappingURL=index.mjs.map
